




























import { USER_NS } from '~/store/modules/shared/user/state'
import { mapGetters } from 'vuex'
import { defineComponent } from '~/utils/nuxt3-migration'
import { ciUser } from '~/icons/source/solid/user'

export default defineComponent({
  props: {
    isActive: { type: Boolean, required: false, default: false },
    avatar: { type: String, required: false, default: '' },
    alt: { type: String, required: false, default: '' },
    clickable: { type: Boolean, required: false, default: false },
    participantId: { type: Number, required: false, default: null }
  },
  setup() {
    return { ciUser }
  },
  computed: {
    ...mapGetters(USER_NS, {
      isAdmin: 'isAdmin'
    })
  }
})
